"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var types = _interopRequireWildcard(require("./types"));
var _selectors = require("../session/selectors");
var _constants = require("./constants");
var _constants2 = require("../websocket/constants");
var _actions = require("../websocket/actions");
var _types2 = require("../websocket/types");
var _config = _interopRequireDefault(require("../../config"));
var _manager = _interopRequireDefault(require("../websocket/manager"));
var typesRoom = _interopRequireWildcard(require("../rooms/types"));
var _apis = require("../rooms/apis");
var _selectors2 = require("../rooms/selectors");
var _axios = require("axios");
var _selectors3 = require("../network/selectors");
var _sagas2 = require("../rooms/sagas");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
var _peerManager = _interopRequireDefault(require("../../utils/peerManager"));
var _streamManager = _interopRequireDefault(require("../../utils/streamManager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('saga:webRTC');
var replayICEFromWS = {};
function handleSDPAnswerFromWS(_ref) {
  var {
    payload: {
      jsep,
      token,
      _client,
      _entity,
      focusOn
    }
  } = _ref;
  return function* () {
    logger.log('handleSDPFromWS ', {
      jsep,
      token,
      _client,
      _entity,
      focusOn
    });
    var peer = _peerManager.default.getPeer({
      _entity,
      _client,
      token
    });
    if (peer && jsep) {
      var videoBitrate = peer.pc.getVideoBitrate();
      var isSetMediaBitrateExist = _callbacks.default.isExist('setMediaBitrate');
      if (videoBitrate && isSetMediaBitrateExist) {
        peer.pc.signal(_objectSpread(_objectSpread({}, jsep), {}, {
          sdp: _callbacks.default.get('setMediaBitrate')(jsep.sdp, 'video', videoBitrate)
        }));
      } else {
        peer.pc.signal(jsep);
      }
    } else {
      logger.warn('handleSDPFromWS:skip no peer or jsep', {
        jsep,
        token,
        _client,
        _entity,
        focusOn,
        peer
      });
    }
  }();
}
function* handleICEFromWS(data) {
  var {
    payload: {
      candidates,
      token,
      _client,
      _entity
    }
  } = data;
  logger.debug('handleIceFromWS', candidates === null || candidates === void 0 ? void 0 : candidates.length, {
    candidates,
    token,
    _client,
    _entity
  });
  var peer = _peerManager.default.getPeer({
    _entity,
    _client,
    token
  });
  if (peer && candidates) {
    logger.log('handleIceFromWS: consume candidate', candidates, token);
    candidates.forEach(candidate => {
      peer.pc.signal({
        candidate
      });
    });
  } else if (!peer && !replayICEFromWS[token]) {
    replayICEFromWS[token] = candidates;
    logger.warn('handleIceFromWS: stack candidate because no peer exists - creating and saving session for replay', {
      candidates,
      token,
      _client,
      _entity,
      peer
    });
  } else if (!peer && replayICEFromWS[token]) {
    replayICEFromWS[token] = replayICEFromWS[token].concat(candidates);
    logger.warn('handleIceFromWS: stack candidate because no peer exists - saving session for replay', {
      candidates,
      token,
      _client,
      _entity,
      peer
    });
  } else {
    logger.error('handleIceFromWS: skip because no candidates is provided', {
      candidates,
      token,
      _client,
      _entity,
      peer
    });
  }
}
function handlePeerStream(_ref2) {
  var {
    payload: {
      _entity,
      _client,
      stream,
      token,
      isTrashable,
      profile
    }
  } = _ref2;
  return function* () {
    logger.log('handlePeerStream', {
      _entity,
      _client,
      stream,
      token,
      isTrashable,
      profile
    }, token);

    // TODO : move this code in peerManager, but need to avoid import loop
    _streamManager.default.setStream({
      _client,
      stream,
      profile,
      token,
      _entity,
      remote: true
    });
  }();
}
function closePCLogic(_ref3) {
  var {
    payload: {
      token,
      _entity,
      _client,
      triggeredByRemote
    }
  } = _ref3;
  return function* () {
    try {
      logger.log('closePCLogic', {
        token,
        _entity,
        _client
      });
      _peerManager.default.removePeer({
        token,
        _entity,
        _client
      });
      yield (0, _effects.call)(_streamManager.default.removeStreamsByToken, token, !triggeredByRemote);
      yield (0, _effects.call)(updateMembersLogic, {
        token,
        _entity,
        _client
      });
      if (replayICEFromWS[token]) {
        logger.log('closePCLogic clean replayICEFromWS', replayICEFromWS[token]);
        delete replayICEFromWS[token];
      }
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'sagas:rooms:closePCLogic');
    }
  }();
}
function* updateMembersLogic(args) {
  yield (0, _effects.delay)(500);
  yield (0, _effects.call)(_sagas2.updateMember, {
    payload: args
  });
}
function createPCLogic(_ref4) {
  var {
    payload: {
      token,
      _entity,
      profile,
      remoteProfile,
      isTrashable,
      _client,
      _user,
      jsep,
      focusOn,
      RTCConfiguration,
      previousToken
    },
    type
  } = _ref4;
  return function* (_config$webRTC) {
    logger.log('createPCLogic', {
      token,
      _entity,
      profile,
      remoteProfile,
      isTrashable,
      _client,
      _user,
      jsep,
      focusOn,
      RTCConfiguration,
      previousToken
    });
    var sdpResponseType;
    if (type === types.WS_WRTC_PC_REQUEST) {
      sdpResponseType = 'offer';
    }
    if (type === types.WS_WRTC_SDP_OFFER) {
      sdpResponseType = 'answer';
    }
    var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);

    // It's useless to create PC in order to get your stream
    if (_client === _myClient) return;

    // If HD is not enabled or HD Publisher is disallowed, reject the PC Create for High resolution stream
    if ((!_config.default.webRTC.HDEnabled || _config.default.webRTC.HDPublisherNotSupported) && (profile === null || profile === void 0 ? void 0 : profile.key) === 'high') {
      logger.log('createPCLogic Publisher HD rejected');
      return;
    }

    // If HD is not enabled and we want to overwrite the bitrate set by the back
    // currently, use because if we create more than one stream with video, only one track will get video track activated on Mobile
    if (!_config.default.webRTC.HDEnabled && (profile === null || profile === void 0 ? void 0 : profile.key) === 'low' && _config.default !== null && _config.default !== void 0 && (_config$webRTC = _config.default.webRTC) !== null && _config$webRTC !== void 0 && _config$webRTC.OverwriteLowBitrate) {
      logger.log('createPCLogic LD redefined');
      profile.videoBitrate = _config.default.webRTC.OverwriteLowBitrate;
    }

    // If HD is not enabled , reject to get the High resolution stream for the USER FOCUS
    if (!_config.default.webRTC.HDEnabled) {
      if ((remoteProfile === null || remoteProfile === void 0 ? void 0 : remoteProfile.key) === 'high') {
        logger.error('createPCLogic subscriber HD rejected');
        return;
      }
    }

    // compute profile sent
    // deduce the profile to be used (remoteProfile/profile) by the PC
    // @TODO : remove the profile usage from the backend and manage it directly with the PC
    // ------
    // .key property used for PC reset (which is currently not used) but prefer to not use it
    // because this is just a label and not usefull.
    var profileCompute = !jsep ? profile : remoteProfile;
    if (!profileCompute) {
      logger.error('Cannot create peer without profile defined', !!jsep, !!profile, !!remoteProfile);
      return;
    }

    // create peer connection
    var peer = _peerManager.default.getPeer({
      _entity,
      _client,
      token
    });
    if (!peer) {
      var _peer$pc;
      var stream = null;
      if (profile !== null && profile !== void 0 && profile.audio || profile !== null && profile !== void 0 && profile.video || profile !== null && profile !== void 0 && profile.screenSharing) {
        stream = yield (0, _effects.call)(_streamManager.default.getLocalStream, {
          video: (profile === null || profile === void 0 ? void 0 : profile.video) || false,
          audio: (profile === null || profile === void 0 ? void 0 : profile.audio) || false,
          screen: (profile === null || profile === void 0 ? void 0 : profile.screenSharing) || false,
          _client: _myClient,
          profile,
          token,
          _entity
        });
      }

      // Remove previous peer if exists by the same client / entity / profile.key / PC description type or previous token
      _peerManager.default.removePreviousPeer({
        _entity,
        _client,
        profile: profileCompute,
        type: sdpResponseType,
        previousToken
      });
      peer = yield _peerManager.default.addPeer({
        _entity,
        _client,
        profile: profileCompute,
        token,
        settings: {
          isInitiator: !jsep,
          stream,
          isTrashable,
          RTCConfiguration
        }
      });
      if ((_peer$pc = peer.pc) !== null && _peer$pc !== void 0 && (_peer$pc = _peer$pc.getPeer()) !== null && _peer$pc !== void 0 && _peer$pc._pc) {
        peer.pc.getPeer()._pc.onconnectionstatechange = e => {
          var _webSocketManager$get;
          _callbacks.default.get('dispatch')({
            type: types.WRTC_CONNECTION_STATE_CHANGE,
            payload: {
              _entity,
              token,
              state: e.target.connectionState,
              profileKey: profileCompute.key
            }
          });
          (_webSocketManager$get = _manager.default.getWs(_constants2.WEBSOCKET_NAME)) === null || _webSocketManager$get === void 0 || _webSocketManager$get.send({
            code: types.WRTC_CONNECTION_STATE_CHANGE,
            payload: {
              _entity,
              token,
              state: e.target.connectionState,
              profileKey: profileCompute.key
            }
          });
          if (e.target.connectionState === 'disconnected' && profile !== null && profile !== void 0 && profile.video) {
            _streamManager.default.removeStreamsByToken(token);
          }
          if (e.target.connectionState === 'disconnected' && !peer._isReconnecting) {
            var _webSocketManager$get2;
            peer._isReconnecting = true;
            (_webSocketManager$get2 = _manager.default.getWs(_constants2.WEBSOCKET_NAME)) === null || _webSocketManager$get2 === void 0 || _webSocketManager$get2.send({
              code: "WRTC_PC_RESET",
              payload: {
                _entity,
                token
              }
            });
          }
        };
      }
    }

    // replay previous missed ICEs
    if (replayICEFromWS[token] && peer) {
      logger.log('createPCLogic replayICEFromWS', replayICEFromWS[token], token);
      replayICEFromWS[token].forEach(candidate => {
        if (candidate) {
          var _peer;
          peer.pc.signal({
            candidate
          });
          logger.log('createPCLogic replayICEFromWS go', candidate, token, (_peer = peer) === null || _peer === void 0 || (_peer = _peer.pc) === null || _peer === void 0 || (_peer = _peer.getPeer()) === null || _peer === void 0 ? void 0 : _peer._pc);
        } else {
          logger.log('createPCLogic replayICEFromWS ignore because candidate is empty', candidate, token);
        }
      });
      delete replayICEFromWS[token];
    }
    if (jsep && peer) {
      var videoBitrate = peer.pc.getVideoBitrate();
      var isVideo = profileCompute === null || profileCompute === void 0 ? void 0 : profileCompute.video;
      var isSetMediaBitrateExist = _callbacks.default.isExist('setMediaBitrate');
      if (videoBitrate && isVideo && isSetMediaBitrateExist) {
        peer.pc.signal(_objectSpread(_objectSpread({}, jsep), {}, {
          sdp: _callbacks.default.get('setMediaBitrate')(jsep.sdp, 'video', videoBitrate)
        }));
      } else {
        peer.pc.signal(jsep);
      }
    }
    if (focusOn) {
      _streamManager.default.setFocus({
        _client,
        _entity
      });
    }
    yield (0, _effects.call)(updateMembersLogic, {
      _client,
      token,
      _entity,
      state: _constants.WEBRTC_STATES.INIT
    });
  }();
}
function handleIceStateChange(_ref5) {
  var {
    payload: {
      _client,
      _entity,
      token,
      iceConnectionState,
      isTrashable,
      iceGatheringState
    }
  } = _ref5;
  return function* (_peer$profile) {
    logger.log('handleIceStateChange ', iceGatheringState, iceConnectionState, token);
    var peer = _peerManager.default.getPeer({
      _entity,
      _client,
      token
    });
    if (iceConnectionState === 'failed') {
      if (!peer._isReconnecting) {
        var _webSocketManager$get3;
        peer._isReconnecting = true;
        (_webSocketManager$get3 = _manager.default.getWs(_constants2.WEBSOCKET_NAME)) === null || _webSocketManager$get3 === void 0 || _webSocketManager$get3.send({
          code: "WRTC_PC_RESET",
          payload: {
            _entity,
            token
          }
        });
      }
    }
    yield (0, _effects.put)((0, _actions.websocketSend)({
      code: "WRTC_ICE_CONNECTION_STATE_CHANGE",
      payload: {
        _entity,
        token,
        state: iceConnectionState,
        profileKey: peer === null || peer === void 0 || (_peer$profile = peer.profile) === null || _peer$profile === void 0 ? void 0 : _peer$profile.key
      }
    }));
    if (iceGatheringState === 'complete') {
      var _peer2$pc;
      var _peer2 = _peerManager.default.getPeer({
        _entity,
        _client,
        token
      });
      var pc = _peer2 === null || _peer2 === void 0 || (_peer2$pc = _peer2.pc) === null || _peer2$pc === void 0 || (_peer2$pc = _peer2$pc.getPeer()) === null || _peer2$pc === void 0 ? void 0 : _peer2$pc._pc;
      if (typeof (pc === null || pc === void 0 ? void 0 : pc.getSenders) === 'function') {
        var _pc$getSenders, _pc$getSenders$getSel;
        var selectedCandidatePair = (_pc$getSenders = pc.getSenders()) === null || _pc$getSenders === void 0 || (_pc$getSenders = _pc$getSenders[0]) === null || _pc$getSenders === void 0 || (_pc$getSenders = _pc$getSenders.transport) === null || _pc$getSenders === void 0 || (_pc$getSenders = _pc$getSenders.iceTransport) === null || _pc$getSenders === void 0 || (_pc$getSenders$getSel = _pc$getSenders.getSelectedCandidatePair) === null || _pc$getSenders$getSel === void 0 ? void 0 : _pc$getSenders$getSel.call(_pc$getSenders);
        if (selectedCandidatePair) {
          logger.log('Send selected ice candidate pair', selectedCandidatePair);
          yield (0, _effects.put)((0, _actions.websocketSend)({
            code: "WRTC_SELECTED_CANDIDATE_PAIR",
            payload: {
              _entity,
              token,
              selectedCandidatePair
            }
          }));
        } else {
          logger.debug('Method: getSelectedCandidatePair not supported');
        }
      } else {
        logger.debug('Method: getSenders not supported');
      }
    }
    if (!_client || _client === _constants.JANUS_CLIENT_ID) return;
    var stateValues = {
      new: _constants.WEBRTC_STATES.INIT,
      checking: _constants.WEBRTC_STATES.CONNECTING,
      completed: _constants.WEBRTC_STATES.CONNECTED,
      connected: _constants.WEBRTC_STATES.CONNECTED,
      failed: _constants.WEBRTC_STATES.FAILED,
      closed: _constants.WEBRTC_STATES.CLOSED,
      disconnected: _constants.WEBRTC_STATES.DISCONNECTED
    };
    if (stateValues[iceConnectionState] && !isTrashable) {
      yield (0, _effects.call)(_sagas2.updateMember, {
        payload: {
          _client,
          _entity,
          token,
          isTrashable,
          state: stateValues[iceConnectionState]
        }
      });
    }
  }();
}
function handleIceError(_ref6) {
  var {
    payload: {
      _entity,
      token,
      error
    }
  } = _ref6;
  return function* () {
    var {
      errorCode,
      errorText,
      port,
      address,
      url
    } = error;
    logger.error('handleIceError ', {
      _entity,
      token,
      error
    });
    yield (0, _effects.put)((0, _actions.websocketSend)({
      code: "WRTC_ICE_ERROR",
      payload: {
        error: JSON.stringify({
          errorCode,
          errorText,
          address,
          port,
          url
        }),
        _entity,
        token
      }
    }));
  }();
}
function handlePeerError(_ref7) {
  var {
    payload: {
      _entity,
      token,
      error
    }
  } = _ref7;
  return function* () {
    logger.error('handlePeerError ', {
      _entity,
      token,
      error
    });
    yield (0, _effects.put)((0, _actions.websocketSend)({
      code: "WRTC_PC_ERROR",
      payload: {
        error,
        _entity,
        token
      }
    }));
  }();
}
function handlePeerStats(_ref8) {
  var {
    payload: {
      stats,
      token,
      _entity,
      isAudioEnabled,
      isVideoEnabled,
      streamId,
      firstStats
    }
  } = _ref8;
  return function* (_stats$audio, _stats$audio2, _stats$audio3, _stats$audio4, _stats$audio5, _stats$audio6) {
    logger.log('handlePeerStats', {
      firstStats,
      remote: !!(stats !== null && stats !== void 0 && (_stats$audio = stats.audio) !== null && _stats$audio !== void 0 && _stats$audio.bytesReceived),
      local: !!(stats !== null && stats !== void 0 && (_stats$audio2 = stats.audio) !== null && _stats$audio2 !== void 0 && _stats$audio2.bytesSent),
      streamId,
      stats,
      token,
      _entity,
      isAudioEnabled,
      isVideoEnabled
    });
    if (streamId) _streamManager.default.setStats(streamId, stats);
    if (firstStats) {
      yield (0, _effects.call)(_sagas2.updateMember, {
        payload: {
          _entity,
          token
        }
      });
    }
    console.log('####stats?.audio?.audioInputLevel: ', stats === null || stats === void 0 || (_stats$audio3 = stats.audio) === null || _stats$audio3 === void 0 ? void 0 : _stats$audio3.audioInputLevel, typeof (stats === null || stats === void 0 || (_stats$audio4 = stats.audio) === null || _stats$audio4 === void 0 ? void 0 : _stats$audio4.audioInputLevel));
    if (stats !== null && stats !== void 0 && (_stats$audio5 = stats.audio) !== null && _stats$audio5 !== void 0 && _stats$audio5.audioInputLevel && (stats === null || stats === void 0 || (_stats$audio6 = stats.audio) === null || _stats$audio6 === void 0 ? void 0 : _stats$audio6.audioInputLevel) >= 0) {
      yield (0, _effects.put)((0, _actions.websocketSend)({
        code: 'WRTC_PC_STATS',
        payload: {
          _entity,
          token,
          audioLevel: Math.floor(stats.audio.audioInputLevel) // the value is between 0 and 32767
        }
      }));
    }
  }();
}

function handlePeerStreamChange(_ref9) {
  var {
    payload: {
      _entity,
      token,
      _client,
      hasAudio,
      hasCamera,
      hasScreen
    }
  } = _ref9;
  return function* () {
    yield (0, _effects.call)(_sagas2.updateMember, {
      payload: {
        _client,
        _entity,
        token,
        hasAudio,
        hasCamera,
        hasScreen
      }
    });
  }();
}
function handlePcReset(_ref10) {
  var {
    _client,
    profileKey = 'audioLow'
  } = _ref10;
  return function* () {
    var _entity = yield (0, _effects.select)(_selectors2._currentRoomSelector);
    var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);
    var _peerClient = _client === _myClient ? 'janus' : _client;
    var peer = _peerManager.default.getPeer({
      _entity,
      _client: _peerClient
    });
    if (!_client) {
      yield (0, _effects.call)(_errorHandler.default.captureException, new Error('No client provided for handlePcReset'), 'saga:webrtc:handlePcReset');
    }
    if (peer) {
      var _Object$values;
      var pc = (_Object$values = Object.values(peer)) === null || _Object$values === void 0 ? void 0 : _Object$values.find(p => {
        var _p$profile;
        return p._client === _peerClient && (p === null || p === void 0 || (_p$profile = p.profile) === null || _p$profile === void 0 ? void 0 : _p$profile.key) === profileKey;
      });
      if (!pc) {
        yield (0, _effects.call)(_errorHandler.default.captureException, new Error('No pc found to reset'), 'saga:webrtc:handlePcReset');
        logger.error('handlePcReset: no PC found to reset', {
          _client,
          _peerClient,
          _entity,
          peer
        });
        return;
      }
      var token = peer === null || peer === void 0 ? void 0 : peer.token;
      if (token) {
        logger.log('handlePcReset', {
          _client,
          _entity,
          peer
        });
        yield (0, _effects.put)((0, _actions.websocketSend)({
          code: 'WRTC_PC_RESET',
          payload: {
            _entity,
            token
          }
        }));
      } else {
        logger.warn('handlePcReset: no token found', {
          _client,
          _peerClient,
          _entity
        });
      }
    } else {
      logger.warn('handlePcReset: no peer found for _client ', {
        _client,
        _peerClient,
        _entity
      });
    }
  }();
}
function* processRoomAlive(_entity) {
  var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);
  var isLeaved = false;
  try {
    while (true) {
      var isWsOpen = yield (0, _effects.select)(_selectors3.isBackendReachable);
      if (isWsOpen) {
        logger.log('handleWSDisconnected:reconnected', isWsOpen);
        (0, _effects.cancel)();
        return;
      }

      // each interval, send ping to backend to say "hey ! I'm alive, don't delete me !!!!"
      var response = yield (0, _effects.call)(_apis.$patchRoomAlive, _entity, _myClient);
      logger.warn('handleWSDisconnected:sending degraded alive ping');
      yield (0, _effects.put)({
        code: 'ROOM_UPDATE',
        type: typesRoom.WS_ROOM_UPDATE,
        payload: response.data,
        source: 'pingBackendRoomAlive'
      });
      yield (0, _effects.delay)(_config.default.room.backendPingIntervalOnWsDown);
    }
  } catch (e) {
    var _e$response;
    if (e instanceof _axios.AxiosError && ((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404) {
      logger.warn('handleWSDisconnected:2ndTry:catch:endCall (404)', _entity);
      isLeaved = true;
      yield (0, _effects.put)({
        type: typesRoom.WS_ROOM_DELETE,
        payload: {
          id: _entity
        }
      });
    } else {
      logger.error('handleWSDisconnected:2ndTry:catch:needCheckAlive', _entity);
    }
  } finally {
    // nothing we can do, leave room  if not already done
    isLeaved = true;
    if (!isLeaved) {
      logger.warn('handleWSDisconnected:finally:connection expired, cannot find network, closing room', _entity);
      yield (0, _effects.put)({
        type: typesRoom.WS_ROOM_DELETE,
        payload: {
          id: _entity
        }
      });
    }
  }
}
function* handleWSDisconnected() {
  var _entities = _peerManager.default.getCurrentEntities();
  logger.debug('handleWSDisconnected', _entities);
  if (_entities !== null && _entities !== void 0 && _entities.length) {
    for (var _entity of _entities) {
      try {
        yield (0, _effects.call)(_apis.$headRoom, _entity);
      } catch (e) {
        var _e$response2;
        if (e instanceof _axios.AxiosError && ((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 404) {
          // remove from _entities then call endCall
          logger.warn('handleWSDisconnected:1stTry:catch:endCall (404)', e, _entity);
          yield (0, _effects.put)({
            type: typesRoom.WS_ROOM_DELETE,
            payload: {
              id: _entity
            }
          });
        } else {
          logger.error('handleWSDisconnected:1stTry:catch', e, _entity);
        }
      }
    }
    var {
      timeout
    } = yield (0, _effects.race)({
      connect: (0, _effects.take)(_types2.WS_CONNECT),
      timeout: (0, _effects.delay)(_config.default.room.backendPingIntervalOnWsDown) // should be < 60s because backend job is each 60s to clean "dead" member
    });

    logger.log('handleWSDisconnected:race', !!timeout, _entities);
    if (timeout && _entities.length) {
      for (var _entity2 of _entities) {
        yield (0, _effects.fork)(processRoomAlive, _entity2);
      }
      yield (0, _effects.take)(_types2.WS_CONNECT); // don't close saga until WS_CONNECT (to avoid multiple run)
    }
  }
}

function* root() {
  yield (0, _effects.all)([(0, _sagas.takeEvery)([types.WS_WRTC_PC_REQUEST, types.WS_WRTC_SDP_OFFER], createPCLogic), (0, _sagas.takeEvery)(types.WS_WRTC_PC_CLOSE, closePCLogic), (0, _sagas.takeEvery)(types.WS_WRTC_SDP_ANSWER, handleSDPAnswerFromWS), (0, _sagas.takeEvery)(types.WS_WRTC_ICE_CANDIDATES, handleICEFromWS), (0, _sagas.takeEvery)(types.WRTC_ON_PC_ERROR, handlePeerError), (0, _sagas.takeLatestByProp)(types.WRTC_ON_PC_ICE_STATE_CHANGE, 'token', handleIceStateChange)(), (0, _sagas.takeLatestByProp)(types.WRTC_ON_PC_ICE_ERROR, 'token', handleIceError)(), (0, _sagas.takeEvery)(types.WRTC_ON_PC_STREAM, handlePeerStream), (0, _sagas.takeEvery)(types.WRTC_ON_PC_STATS, handlePeerStats), (0, _sagas.takeEvery)(types.WRTC_PC_RESET, handlePcReset), (0, _sagas.takeLatestByProp)(types.WRTC_ON_PC_STREAM_CHANGE, 'token', handlePeerStreamChange)(), (0, _sagas.takeLeading)([_types2.WS_CLOSE], handleWSDisconnected)]);
}
module.exports = exports.default;